<template>
  <div :class="$style.page">
    <div :class="$style.layout">
      <slot />
    </div>
  </div>
</template>

<style module>
.page {
  padding: var(--layout-header-height-mobile) 0 0 0;
  background: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: flex-start;

  @media screen and (min-width: 740px) {
    padding: calc(120px + 36px) 0 36px 0;
    background: var(--color-lightblue);
  }
}

.layout {
  margin: 0;
  border-radius: var(--radius-default);
  background: var(--color-white);
  padding: 0;
  width: 100%;
  position: relative;

  @media screen and (min-width: 740px) {
    max-width: 650px;
    border: 1px solid var(--color-blackcoral-50);
    box-shadow: 0 4px 4px var(--color-blackcoral-10);

    &:empty {
      border: 0;
    }
  }
}
</style>
